import { useState, useEffect } from 'react';

const navItems = [
  { name: '首页', href: '#hero' },
  { name: '平台介绍', href: '#about' },
  { name: '常见问答', href: '#faq' },
  { name: '联系我们', href: '#contact' },
  { name: '主题索引', href: '#index' },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const handleNavClick = (href: string) => {
    setMobileOpen(false);
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-[72px]">
          <a
            href="#hero"
            onClick={(e) => {
              e.preventDefault();
              handleNavClick('#hero');
            }}
            className="flex items-center gap-2 text-foreground-950 no-underline"
          >
            <span className="w-9 h-9 flex items-center justify-center bg-primary-500 text-background-50 rounded-lg">
              <i className="ri-movie-2-line text-lg"></i>
            </span>
            <span className="font-heading text-xl text-foreground-950 whitespace-nowrap">91影视</span>
          </a>

          <nav className="hidden md:flex items-center gap-1">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={(e) => {
                  e.preventDefault();
                  handleNavClick(item.href);
                }}
                className="px-4 py-2 text-sm text-foreground-700 hover:text-primary-600 rounded-md transition-colors whitespace-nowrap cursor-pointer"
              >
                {item.name}
              </a>
            ))}
          </nav>

          <div className="hidden md:flex items-center gap-3">
            <a
              href="#app"
              onClick={(e) => {
                e.preventDefault();
                handleNavClick('#app');
              }}
              className="px-5 py-2 text-sm font-medium text-background-50 bg-primary-500 hover:bg-primary-600 rounded-md transition-colors whitespace-nowrap cursor-pointer"
            >
              下载 App
            </a>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-700 hover:text-primary-600 rounded-md cursor-pointer"
            aria-label="打开菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70 shadow-lg">
          <nav className="flex flex-col px-4 py-3 gap-1">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={(e) => {
                  e.preventDefault();
                  handleNavClick(item.href);
                }}
                className="px-4 py-3 text-sm text-foreground-700 hover:text-primary-600 hover:bg-background-100 rounded-md transition-colors cursor-pointer"
              >
                {item.name}
              </a>
            ))}
            <a
              href="#app"
              onClick={(e) => {
                e.preventDefault();
                handleNavClick('#app');
              }}
              className="mt-2 mx-4 mb-2 px-5 py-3 text-sm font-medium text-background-50 bg-primary-500 hover:bg-primary-600 rounded-md transition-colors text-center cursor-pointer"
            >
              下载 App
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}